import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@ensafely/checker-ui";
import { api } from "@/lib/api";
import { setToken } from "../lib/authToken";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const res = await api.post<{ token: string }>("/auth/login", { email, password });
      setToken(res.token);
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-sm bg-card rounded-lg shadow p-8">
        <Logo variant="horizontal" className="h-9 w-auto mb-6" />
        <h1 className="text-2xl font-bold mb-6">Log in to Checker Cloud</h1>
        {error && <p className="text-red-600 text-sm mb-4">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} required
            className="w-full border rounded px-3 py-2 text-sm bg-background"
          />
          <input
            type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} required
            className="w-full border rounded px-3 py-2 text-sm bg-background"
          />
          <div className="text-right">
            <Link to="/forgot-password" className="text-xs text-muted-foreground hover:text-primary hover:underline">
              Forgot password?
            </Link>
          </div>
          <button type="submit" className="w-full bg-primary text-primary-foreground rounded py-2 text-sm hover:opacity-90">
            Log in
          </button>
        </form>
        <p className="text-sm text-muted-foreground mt-4 text-center">
          Don't have an account? <Link to="/signup" className="text-primary hover:underline">Sign up</Link>
        </p>
      </div>
    </div>
  );
}
